import { mapOmnitureData, SearchMigrationAdapter } from 'src/common/stores/adapters/bex-api';

import { HotelResultsViewModel } from 'models';

import { OperationResult } from '__generated__/api/api-operations';
import { PropertyMapMigration } from '__generated__/api';

export const adaptAnalytics: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { extensions } = bexApiResults;

  if (!extensions) {
    return bffResults;
  }

  const { analytics } = extensions;

  if (!analytics) {
    return bffResults;
  }

  return {
    ...bffResults,
    omnitureData: mapOmnitureData(analytics)
  };
};
